


















































































import store from '../../../store'
import DataTable from '../../../components/DataTable.vue'
import PageTitle from '../../../components/PageTitle.vue'
import { stockCalculations } from '../../../mixins/mixins'
import dayjs from 'dayjs'
const CODES = require('../../../data/Codes.json')

export default {
  mixins: [stockCalculations],
  data () {
    return {
      name: 'Rotation 1',
      date: dayjs().format('YYYY-MM-DD'),
      rotation: {
        name: null,
        date: new Date(),
        area: 0,
        wastage: 0,
        decay: 0
      },
      stock1: {
        type: null,
        weight: null,
        state: null,
        pregnancy: null,
        number: 0,
        intake: 0,
        energy: 0
      },
      stock2: {
        type: null,
        weight: null,
        state: null,
        pregnancy: null,
        number: 0,
        intake: 0,
        energy: 0
      },
      stock3: {
        type: null,
        weight: null,
        state: null,
        pregnancy: null,
        number: 0,
        intake: 0,
        energy: 0
      },
      rotationHeaders: [
        { text: 'Field', value: 'label' },
        { text: 'Data', value: 'data.value' },
        { text: 'Calculations & comments', value: 'notes.message' }
      ],
      paddockData: [],
      paddock: {
        name: '',
        order: 0,
        area: 0,
        fooStart: 0,
        quality: '',
        growth: 0,
        target: 0,
        energyIntake: 0,
        grazing: 0,
        pastureIntake: 0,
        daysLasting: 0,
        daysSinceRotationStart: 0,
        moveStockDate: 'N/A',
        growthBetweenRotations: 0,
        daysRestBeforeNextGrazing: 0,
        fooNext: 0
      },
      paddockHeaders: [
        { text: 'Name', value: 'name' },
        { text: 'Order of rotation', value: 'order' },
        { text: 'Area (Ha)', value: 'area' },
        { text: 'FOO on measurment date (Kg/DM/Ha)', value: 'fooStart' },
        { text: 'Pasture quality', value: 'quality' },
        { text: 'Estimated pasture growth per day (Kg/DM/Ha/Day)', value: 'growth' },
        { text: 'Target FOO when animals removed', value: 'target' },
        { text: 'Energy intake from pasture at FOO (MJ ME/Hd/Day)', value: 'energyIntake' },
        { text: 'FOO when animals are grazing', value: 'grazing' },
        { text: 'Estimated pasture intake (Kg/DM/Ha/Day)', value: 'pastureIntake' },
        { text: 'Number of days paddock will last', value: 'daysLasting' },
        { text: 'Days since start of rotation', value: 'daysSinceRotationStart' },
        { text: 'Date to move stock to next paddock', value: 'moveStockDate' },
        { text: 'Pasture growth rate between rotations', value: 'growthBetweenRotations' },
        { text: 'Total days rest before next grazing', value: 'daysRestBeforeNextGrazing' },
        { text: 'FOO at start of next rotation', value: 'fooNext' },
        { text: '', value: 'delete' }
      ]
    }
  },

  // Populate on create if data exists
  created: function (this:any) {
    this.getPaddockData()
    if (store.state.seasonalPasture3 !== null) {
      this.stock1 = store.state.seasonalPasture3.stock1
      this.stock2 = store.state.seasonalPasture3.stock2
      this.stock3 = store.state.seasonalPasture3.stock3
      this.rotation = store.state.seasonalPasture3.rotation
      this.rotationHeaders = store.state.seasonalPasture3.rotationHeaders
      this.paddock = store.state.seasonalPasture3.paddock
      this.paddockHeaders = store.state.seasonalPasture3.paddockHeaders
      this.paddockData = store.state.seasonalPasture3.paddockData
    }
  },

  // Update state on component value changes
  updated: function (this:any) {
    store.dispatch('updateSeasonalPasture3', this.$data)
  },

  // Update state on component destroy
  beforeDestroy: function (this:any) {
    store.dispatch('updateSeasonalPasture3', this.$data)
  },

  watch: {
    rotationData: function (this:any) {
      this.updatePaddockResults()
    }
  },

  computed: {
    rotationData: {
      get: function (this:any) {
        let tdataArr:any = []

        // PADDOCK DETAILS

        let paddockArr:any[] = [
          {
            category: 'rotation',
            code: 'name',
            label: 'Name',
            data: {
              display: 'input',
              type: 'string',
              value: this.rotation.name
            },
            notes: { message: null }
          },
          {
            category: 'rotation',
            code: 'date',
            label: 'Start date',
            data: {
              display: 'input',
              type: 'date',
              value: this.rotation.date
            },
            notes: { message: null }
          },
          {
            category: 'rotation',
            code: 'area',
            label: 'Total area',
            data: {
              display: 'text',
              type: 'number',
              value: this.rotation.area
            },
            notes: {
              message: 'Sum of all areas listed in paddock table below.'
            }
          },
          {
            category: 'rotation',
            code: 'wastage',
            label: 'Consumption wastage factor',
            data: {
              display: 'input',
              type: 'number',
              value: this.rotation.wastage,
              suffix: '%'
            },
            notes: {
              message: 'When stock graze pasture some losses occur through trampling and fouling. Wastage is commonly between 15—40% of what is eaten each month. Use lower wastage for low stocking rates and dry paddocks and higher rates for higher stocking rates and wet paddocks.'
            }
          },
          {
            category: 'rotation',
            code: 'decay',
            label: 'Decay wastage factor',
            data: {
              display: 'input',
              type: 'number',
              value: this.rotation.decay,
              suffix: '%'
            },
            notes: {
              message: 'Only use in late spring and summer. In late spring and summer, wastage of pasture is high due to decay, trampling and wind. Wastage of native perennials is 15—20%, introduced perennials 20—30% and for clover-based pastures 30—40% of the available pasture.'
            }
          }]

          // ANIMAL CONSUMPTION

          let stockArr:any[] = []
          for (let i = 1; i <= 3; i++) {
            let currentStock = i === 1 ? this.stock1 : i === 2 ? this.stock2 : this.stock3
            let intakeEnergy = this.getPastureIntakeEnergy(currentStock, { fooStart: 600, quality: '60% dig, 8.2 MJ ME/kg  - Gone to seed' })
            currentStock.intake = intakeEnergy[0]
            currentStock.energy = intakeEnergy[1]
            let hidden = i > 1
            let stock:any = [{
              category: 'stock ' + i,
              code: 'type',
              label: 'Stock type',
              data: {
                display: 'select',
                type: 'string',
                value: currentStock.type,
                items: ['Cows', 'Weaner Cattle', 'Ewes / Wethers', 'Lambs']
              },
              notes: {
                message: null
              },
              hidden: hidden
            },
            {
              category: 'stock ' + i,
              code: 'weight',
              label: 'Average weight',
              data: {
                display: 'select',
                type: 'string',
                value: currentStock.weight,
                items: this.getWeights(currentStock.type),
                suffix: 'kg/Hd'
              },
              notes: {
                message: null
              },
              hidden: hidden
            },
            {
              category: 'stock ' + i,
              code: 'state',
              label: 'Physiological state',
              data: {
                display: 'select',
                type: 'string',
                value: currentStock.state,
                items: this.getPhysiologicalState(currentStock.type)
              },
              notes: {
                message: null
              },
              hidden: hidden
            },
            {
              category: 'stock ' + i,
              code: 'pregnancy',
              label: 'Twins / singles / not applicable',
              data: {
                display: 'select',
                type: 'string',
                value: currentStock.pregnancy,
                items: currentStock.type === 'Ewes / Wethers' && currentStock.state !== 'Dry' ? ['Twins', 'Singles'] : ['Not Applicable']
              },
              notes: {
                message: null,
                link: null
              },
              hidden: hidden
            },
            {
              category: 'stock ' + i,
              code: 'energy',
              label: 'MJ ME/Hd for maintenance',
              data: {
                display: 'text',
                type: 'number',
                value: currentStock.energy
              },
              notes: { message: null },
              hidden: hidden
            },
            {
              category: 'stock ' + i,
              code: 'number',
              label: 'Number of animals in rotation',
              data: {
                display: 'input',
                type: 'number',
                value: currentStock.number
              },
              notes: { message: null },
              hidden: hidden
            }
          ]
          stockArr = stockArr.concat(stock)
        }

        tdataArr = paddockArr.concat(stockArr)
        return tdataArr
      },
      set: function (this:any, newValue:any) {
        // Filter each category into seperate array
        let rotation = newValue.filter((e:any) => e.category === 'rotation')
        let stock1 = newValue.filter((e:any) => e.category === 'stock 1')
        let stock2 = newValue.filter((e:any) => e.category === 'stock 2')
        let stock3 = newValue.filter((e:any) => e.category === 'stock 3')
        // Assign new value to category variables
        rotation.forEach((e:any) => { this.rotation[e.code] = e.data.value })
        stock1.forEach((e:any) => { this.stock1[e.code] = e.data.value })
        stock2.forEach((e:any) => { this.stock2[e.code] = e.data.value })
        stock3.forEach((e:any) => { this.stock3[e.code] = e.data.value })
      }
    },
    newPaddock: function (this:any) {
      return {
        name: { display: 'input', type: 'string', value: this.paddock.name },
        order: { display: 'input', type: 'number', value: this.paddock.order },
        area: { display: 'input', type: 'number', value: this.paddock.area },
        fooStart: { display: 'input', type: 'number', value: this.paddock.fooStart },
        quality: {
          display: 'select',
          type: 'string',
          value: this.paddock.quality,
          items: [
            '40% dig, 4.8 MJ ME/kg - Dry (Dead)',
            '50% dig, 6.5 MJ ME/kg - Dry, perennial',
            '60% dig, 8.2 MJ ME/kg  - Gone to seed',
            '70% dig, 10 MJ ME/kg - Green, grassy',
            '75% dig, 10.8 MJ ME/kg - Green, 15-30% clover',
            '80% dig - 11.6 MJ ME/kg - Green, 60% clover'
          ]
        },
        growth: { display: 'input', type: 'number', value: this.paddock.growth },
        target: { display: 'input', type: 'number', value: this.paddock.target },
        energyIntake: { display: 'text', type: 'number', value: this.paddock.energyIntake },
        grazing: { display: 'text', type: 'number', value: this.paddock.grazing },
        pastureIntake: { display: 'text', type: 'number', value: this.paddock.pastureIntake },
        daysLasting: { display: 'text', type: 'number', value: this.paddock.daysLasting },
        daysSinceRotationStart: { display: 'text', type: 'number', value: this.paddock.daysSinceRotationStart },
        moveStockDate: { display: 'text', type: 'date', value: this.paddock.moveStockDate },
        growthBetweenRotations: { display: 'input', type: 'number', value: this.paddock.growthBetweenRotations },
        daysRestBeforeNextGrazing: { display: 'text', type: 'number', value: this.paddock.daysRestBeforeNextGrazing },
        fooNext: { display: 'text', type: 'number', value: this.paddock.fooNext },
        delete: { display: null, type: null, value: 'delete' }
      }
    }
  },

  methods: {
    // Get paddock data
    getPaddockData: function (this:any) {
      for (let i = 0; i < 3; i++) {
        this.$set(this.paddockData, i, this.cleanSource(this.newPaddock))
      }
    },

    // Add new paddock
    addPaddock: function (this:any) {
      this.$set(this.paddockData, this.paddockData.length, this.cleanSource(this.newPaddock))
    },

    // Remove paddock
    removePaddock: function (this:any, index:number) {
      if (this.paddockData.length > 1) {
        this.paddockData.splice(index, 1)
      }
    },

    // Update the results of the paddock
    updatePaddockResults: function (this:any) {
      let secondRotation:any[] = []
      const stockArr = [this.stock1, this.stock2, this.stock3]
      const totalStockNumber:number = parseInt(this.stock1.number) + parseInt(this.stock2.number) + parseInt(this.stock3.number)

      for (let index = 0; index < this.paddockData.length; index++) {
        let p = this.paddockData[index]
        // Initial Paddock
        if (index === 0) {
          // FOO when animals are grazing
          p.grazing.value = p.fooStart.value

          // Estimated pasture intake
          p.pastureIntake.value = 0
          stockArr.forEach(stock => {
            if (stock.number > 0) {
              let pIntake = this.getPastureIntakeEnergy(stock, { fooStart: p.grazing.value, quality: p.quality.value })
              p.pastureIntake.value += pIntake[0] * (stock.number / totalStockNumber)
            }
          })

          // Energy intake from pasture at FOO
          p.energyIntake.value = 0
          stockArr.forEach(stock => {
            if (stock.number > 0) {
              let eIntake = this.getPastureIntakeEnergy(stock, { fooStart: p.target.value, quality: p.quality.value })
              let digestibility = p.quality.value.includes('40%') ? 0.4
                : p.quality.value.includes('50%') ? 0.5
                  : p.quality.value.includes('60%') ? 0.6
                    : p.quality.value.includes('70%') ? 0.7
                      : p.quality.value.includes('75%') ? 0.75
                        : p.quality.value.includes('80%') ? 0.8
                          : 0.6
              p.energyIntake.value += (eIntake[0] * ((digestibility * 22.587) - 5.2361)) * (stock.number / totalStockNumber)
            }
          })

          // Number of days paddock will last
          p.daysLasting.value = (parseInt(p.grazing.value) - parseInt(p.target.value)) / (((parseFloat(p.pastureIntake.value) * totalStockNumber * (1 + parseInt(this.rotation.wastage) / 100)) / parseInt(p.area.value)) - parseInt(p.growth.value)) || 0
          p.daysLasting.value = p.daysLasting.value >= 0 ? p.daysLasting.value : 0

          // Days since start of rotation
          p.daysSinceRotationStart.value = 0

          // Date to move stock to next paddock
          let date = new Date(this.rotation.date)
          let moveDate:any = date.setDate(date.getDate() + p.daysLasting.value)
          moveDate = new Date(moveDate)
          p.moveStockDate.value = moveDate.getDate() + '/' + (moveDate.getMonth() + 1) + '/' + moveDate.getFullYear()

          // Total days rest before next grazing
          secondRotation[index] = (parseInt(p.fooNext.value) - parseInt(p.target.value)) / (((parseFloat(p.pastureIntake.value) * totalStockNumber * (1 + (parseInt(this.rotation.wastage) / 100)) / parseInt(p.area.value)) - parseInt(p.growthBetweenRotations.value)))
          p.daysRestBeforeNextGrazing.value = 0
          for (let i = index + 1; i < this.paddockData.length; i++) {
            p.daysRestBeforeNextGrazing.value += this.paddockData[i].daysLasting.value
          }
          p.daysRestBeforeNextGrazing.value = p.daysRestBeforeNextGrazing.value >= 0 ? p.daysRestBeforeNextGrazing.value : 0

          // FOO at start of next rotation
          p.fooNext.value = parseInt(p.daysRestBeforeNextGrazing.value) * parseInt(p.growthBetweenRotations.value) + parseInt(p.target.value)
        } else {
          let pPrev = this.paddockData[index - 1]

          // FOO when animals are grazing
          let sumOfDaysLasting = 0
          for (let i = 0; i < index; i++) {
            sumOfDaysLasting += this.paddockData[i].daysLasting.value
          }
          p.grazing.value = parseFloat(p.fooStart.value) + parseFloat(p.growth.value) * (index === 1 ? parseFloat(pPrev.daysLasting.value) : sumOfDaysLasting) - parseFloat(p.fooStart.value) * (Math.pow((this.rotation.decay / 100), ((parseFloat(pPrev.daysSinceRotationStart.value) + parseFloat(pPrev.daysLasting.value)) / 30)))

          // Estimated pasture intake
          p.pastureIntake.value = 0
          stockArr.forEach(stock => {
            if (stock.number > 0) {
              let pIntake = this.getPastureIntakeEnergy(stock, { fooStart: p.grazing.value, quality: p.quality.value })
              p.pastureIntake.value += pIntake[0] * (stock.number / totalStockNumber)
            }
          })

          // Energy intake from pasture at FOO
          p.energyIntake.value = 0
          stockArr.forEach(stock => {
            if (stock.number > 0) {
              let eIntake = this.getPastureIntakeEnergy(stock, { fooStart: p.target.value, quality: p.quality.value })
              let digestibility = p.quality.value.includes('40%') ? 0.4
                : p.quality.value.includes('50%') ? 0.5
                  : p.quality.value.includes('60%') ? 0.6
                    : p.quality.value.includes('70%') ? 0.7
                      : p.quality.value.includes('75%') ? 0.75
                        : p.quality.value.includes('80%') ? 0.8
                          : 0.6
              p.energyIntake.value += (eIntake[0] * ((digestibility * 22.587) - 5.2361)) * (stock.number / totalStockNumber) || 0
            }
          })

          // Number of days paddock will last
          p.daysLasting.value = (parseInt(p.grazing.value) - parseInt(p.target.value)) / (((parseFloat(p.pastureIntake.value) * totalStockNumber * (1 + parseInt(this.rotation.wastage) / 100)) / parseInt(p.area.value)) - parseInt(p.growth.value)) || 0
          p.daysLasting.value = p.daysLasting.value >= 0 ? p.daysLasting.value : 0

          // Days since start of rotation
          p.daysSinceRotationStart.value = pPrev.daysSinceRotationStart.value + pPrev.daysLasting.value || 0

          // Date to move stock to next paddock
          let date = new Date(this.rotation.date)
          let moveDate:any = date.setDate(date.getDate() + Math.round(sumOfDaysLasting))
          moveDate = new Date(moveDate)
          pPrev.moveStockDate.value = moveDate.getDate() + '/' + (moveDate.getMonth() + 1) + '/' + moveDate.getFullYear()
          p.moveStockDate.value = 'N/A'

          // Total days rest before next grazing & FOO at start of next rotation
          let sRotations = 0
          p.daysRestBeforeNextGrazing.value = 0
          p.fooNext.value = 0
          sRotations = secondRotation.reduce((a:any, b:any) => a + b, 0)
          p.daysRestBeforeNextGrazing.value += this.getDays(index) + (index === 1 ? secondRotation[0] : sRotations) || 0
          p.daysRestBeforeNextGrazing.value = p.daysRestBeforeNextGrazing.value >= 0 ? p.daysRestBeforeNextGrazing.value : 0
          p.fooNext.value = (this.getDays(index) + (index === 1 ? secondRotation[0] : sRotations)) * parseInt(p.growthBetweenRotations.value) + parseInt(p.target.value) || 0
          secondRotation[index] = (parseInt(p.fooNext.value) - parseInt(p.target.value)) / (((parseFloat(p.pastureIntake.value) * totalStockNumber * (1 + (parseInt(this.rotation.wastage) / 100)) / parseInt(p.area.value)) - parseInt(p.growthBetweenRotations.value)))
        }
      }
      this.rotation.area = this.getTotalArea()
    },

    // Get combined total area of all paddocks in rotation
    getTotalArea: function (this:any) {
      let area = 0
      for (let i = 0; i < this.paddockData.length; i++) {
        area += parseInt(this.paddockData[i].area.value)
      }
      return area || 0
    },

    // Return the sum of days lasting after the given index
    getDays: function (this:any, index:number) {
      let days = 0
      for (let i = index + 1; i < this.paddockData.length; i++) {
        days += Math.round(this.paddockData[i].daysLasting.value)
      }
      return days
    },

    // OVERWRITES MIXIN - Returns the intake and energy of stock as an array [intake, energy]
    getPastureIntakeEnergy: function (this:any, currentStock?:any, currentPaddock?:any) {
      // Use default stock and paddock if currentPaddock param is not used
      currentStock = currentStock !== undefined ? currentStock : this.stock1
      currentPaddock = currentPaddock !== undefined ? currentPaddock : this.paddock
      let stockCode:any
      let weightCode:any
      let stateCode:any
      let pregnancyCode:any
      let fooCodeA:any
      let fooCodeB:any
      let qualityCode
      let totalCodeA:any
      let totalCodeB:any
      let resultA: any
      let resultB:any
      let intake:any
      let energy:any
      // Stock code
      stockCode = CODES.stocks.filter((e:any) => e.stock === currentStock.type)
      stockCode = stockCode[0] !== undefined ? stockCode[0].code : 0
      // Weight Code
      weightCode = CODES.weights.filter((e:any) => e.stock === currentStock.type)
      weightCode = weightCode[0] !== undefined ? weightCode[0].weights.filter((e:any) => e.weight === currentStock.weight) : 0
      weightCode = weightCode[0] !== undefined ? weightCode[0].code : 0
      // State Code
      stateCode = CODES.states.filter((e:any) => e.state === currentStock.state)
      stateCode = stateCode[0] !== undefined ? stateCode[0].code : 0
      // Pregnancy Code
      pregnancyCode = CODES.pregnancies.filter((e:any) => e.pregnancy === currentStock.pregnancy)
      pregnancyCode = pregnancyCode[0] !== undefined ? pregnancyCode[0].code : 0
      // Feed On Offer Codes
      switch (true) {
        case (currentPaddock.fooStart < 1000):
          fooCodeA = CODES.foo['500']
          break
        case (currentPaddock.fooStart < 1500):
          fooCodeA = CODES.foo['1000']
          break
        case (currentPaddock.fooStart < 2000):
          fooCodeA = CODES.foo['1500']
          break
        case (currentPaddock.fooStart >= 2000):
          fooCodeA = CODES.foo['2000']
          break
      }
      fooCodeB = fooCodeA === 500 ? 600 : fooCodeA === 600 ? 700 : fooCodeA === 700 ? 800 : fooCodeA === 800 ? 800 : fooCodeA
      // Quality Code
      qualityCode = CODES.qualities.filter((e:any) => e.quality === currentPaddock.quality)
      qualityCode = qualityCode[0] !== undefined ? qualityCode[0].code : 0
      // Total Code
      totalCodeA = stockCode + weightCode + stateCode + pregnancyCode + fooCodeA + qualityCode
      totalCodeB = stockCode + weightCode + stateCode + pregnancyCode + fooCodeB + qualityCode
      // Result, Intake & Energy
      resultA = CODES.totals.filter((e:any) => e.code === totalCodeA)
      resultB = CODES.totals.filter((e:any) => e.code === totalCodeB)
      let a = resultA[0] !== undefined ? resultA[0].intake : 0
      let b = resultB[0] !== undefined ? resultB[0].intake : 0
      intake = fooCodeA === 500 ? (((currentPaddock.fooStart - 500) / 500) * (b - a)) + a
        : fooCodeA === 600 ? (((currentPaddock.fooStart - 1000) / 500) * (b - a)) + a
          : fooCodeA === 700 ? (((currentPaddock.fooStart - 1500) / 500) * (b - a)) + a
            : fooCodeA === 800 ? (((currentPaddock.fooStart - 2000) / 500) * (b - a)) + a
              : a
      energy = resultA[0] !== undefined ? resultA[0].energy : 0
      return [intake, energy]
    },

    // Update the tdata with new values
    update: function (this:any, row:any) {
      let updatedtData = this.rotationData
      let oldRow = updatedtData.filter((e:any) => e.category === row.category && e.code === row.code)
      updatedtData[this.rotationData.indexOf(oldRow[0])] = row
      this.rotationData = updatedtData
      this.rotationData.filter((e:any) => e.category === row.category).forEach((e:any) => { e.hidden = false })
    },

    // Using native JSON functions removes reactivity
    // so we can clone an object without mutating the original source
    cleanSource: function (source:any) {
      return JSON.parse(JSON.stringify(source))
    },

    // Load scenario data
    loadScenario: function (this:any, item:any) {
      this.paddockData = item.data1
      this.rotationData = item.data2
    }
  },

  components: {
    DataTable, PageTitle
  },

  store
}
